<div class="d-flex">
  @if (!hidePeriodSelector) {
    <div class="pr-3">
      <span class="text-primary mr-2 font-size-small">
        {{'COMMON.PERIOD' | translate }}
      </span>
      <lib-select
        [options]="periodOptions.names"
        [disabled]="disabled"
        [label]="periodLabel"
        [border]="'custom-border'"
        [classes]="'font-size-normal-small text-primary h-100'"
        [itemClasses]="'font-size-normal-small'"
        [doNotTranslate]="true"
        [container]="''"
        (selectedChanged)="selectPeriod($event)">
      </lib-select>
    </div>
  }
  <div class="d-flex align-items-center">
    <lib-button
      id="data-analysis-left-button"
      [disabled]="disabled"
      [size]="'custom'"
      [width]="50"
      [height]="32"
      [color]="'secondary'"
      [label]="'<'"
      (buttonClicked)="prevPeriod()">
    </lib-button>
    @if (selectedPeriod && (periodLabel === 'Custom' || periodLabel === 'Week')) {
      <input
        [ngClass]="{'disabled': disabled}"
        type="text"
        class="data-analysis-period-input font-size-small cursor-pointer text-primary"
        [bsConfig]="bsConfig | async"
        [bsValue]="selectedPeriod"
        [maxDate]="today"
        (bsValueChange)="changeRangeDate($event)"
        bsDaterangepicker
        />
    }
    @if (selectedDate && periodLabel !== 'Custom' && periodLabel !== 'Week') {
      <input
        type="text"
        [ngClass]="{'disabled': disabled}"
        class="data-analysis-period-input cursor-pointer text-primary"
        [bsConfig]="bsConfig | async"
        [bsValue]="selectedDate"
        [maxDate]="today"
        (bsValueChange)="changeDate($event)"
        bsDatepicker
        />
    }
    <lib-button
      id="data-analysis-right-button"
      [size]="'custom'"
      [width]="50"
      [height]="32"
      [color]="'secondary'"
      [label]="'>'"
      [disabled]="isEndToday || disabled"
      (buttonClicked)="nextPeriod()">
    </lib-button>
  </div>
</div>
